<template>
  <div>
    <b-card-header class="border-0" v-if="!headless">
      <b-row>
        <b-col class="col-sm-10">
          <h3 class="mb-0">Appointments</h3>
        </b-col>
        <b-col style="text-align: right"> </b-col>
      </b-row>
    </b-card-header>

    <table class="table">
      <thead>
        <tr>
          <th>
            Date
          </th>
          <th>
            Customer
          </th>
          <th>
            Customer Balance
          </th>
          <th>
            Provider
          </th>
          <th>
            Services
          </th>

          <th>
            Services Due
          </th>

          <th>
            Status
          </th>
        </tr>
      </thead>

      <template v-for="row in appts">
        <tr
          @click="
            () => {
              $emitter.emit('show-appt', row.id);
            }
          "
        >
          <td>
            {{ row.startDate | moment("MM/DD/YYYY") }} <br />
            <small>
              {{ row.startDate | moment("hh:mm A") }} -
              {{ row.endDate | moment("hh:mm A") }}
            </small>
          </td>
          <td>{{ row.customerName }}</td>
          <td>
            {{ (row.customerBalance / 100) | currency }}
          </td>
          <td>
            {{ row.providerName }}
          </td>
          <td>
            {{ row.services }}
          </td>

          <td>
            {{ (row.servicesDue / 100) | currency }}
          </td>

          <td>
            {{ row.status | title }}
          </td>
        </tr>
      </template>
    </table>

    <b-pagination
      align="center"
      class="mt-3"
      v-if="showPagination"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      @change="pageChange"
    ></b-pagination>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

import swal from "sweetalert2";
import RefundVoid from "@/views/Components/Transactions/RefundVoid";
import Transaction from "@/views/Components/Transactions/Transaction";

export default {
  name: "appt-search-results",

  props: {
    supressPatientName: false,
    supressSource: false,
    headless: false,
    supressOptions: false,
    query: {
      customerId: null,
      startDate: null,
      endDate: null,
    },
  },
  components: {
    "refund-void": RefundVoid,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    transaction: Transaction,
  },
  watch: {
    query: {
      immediate: true,
      async handler(newVal) {
        this.bind(1);
      },
      deep: true,
    },
  },
  mounted() {
    this.$emitter.once("bind-transactions", (e) => {
      this.bind(this.currentPage);
    });
  },
  methods: {
    async bind(page) {
      this.currentPage = page;

      var form = this.query;

      form.currentPage = page;
      form.sortOption = self.sortOption;

      var r = await this.$client.post("/api/appt/getAppts", form);

      this.appts = r.data.value.appts;

      this.rows = r.data.value.rows;

      this.showPagination = this.rows > 10;
    },

    pageChange(page) {
      this.bind(page);
    },
    newSort() {
      var self = this;

      self.bind(page);
    },
  },
  data() {
    return {
      showPagination: false,
      referenceId: null,
      sortOption: "Date:descending",
      rows: null,
      currentPage: 1,
      perPage: 10,
      appts: [],
    };
  },
};
</script>
<style>
.trans-amount {
  display: inline-block;
}
.fa-circle-half-stroke {
  font-size: 0.8em;
  position: relative;
  top: -1px;
  padding-right: 5px;
  color: #fb6340;
}
</style>
